import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  const currentYear = 2025;
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();

    if (location.pathname !== '/') {
      // Navigate to home first, then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer id="footer" className="footer">
      <div className="container">
        {/* Footer Main Content */}
        <div className="footer-content">
          {/* Column 1: Logo & Tagline */}
          <div className="footer-column">
            <div className="footer-logo">
              <span className="logo-text">FortIf</span>
              <span className="logo-badge">AI</span>
            </div>
            <p className="footer-tagline">
              AI-powered resume screening that's fair, fast, and transparent. Revolutionizing how
              companies find great talent.
            </p>
          </div>

          {/* Column 2: Product Links */}
          <div className="footer-column">
            <h4 className="footer-title">Product</h4>
            <ul className="footer-links">
              <li>
                <a href="#features" onClick={(e) => scrollToSection(e, 'features')}>
                  Features
                </a>
              </li>
              <li>
                <a href="#pricing" onClick={(e) => scrollToSection(e, 'pricing')}>
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/integrations">
                  Integrations
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company Links */}
          <div className="footer-column">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li>
                <Link to="/about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal & Support */}
          <div className="footer-column">
            <h4 className="footer-title">Legal & Support</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-contact">
            <p>
              <strong>Contact:</strong> support@fortif.app
            </p>
          </div>
          <div className="footer-copyright">
            <p>
              &copy; {currentYear} FortIf. All rights reserved. Built with care for fair hiring.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
